<template>
  <input
    v-model="model"
    type="checkbox"
    :value="value"
    class="peer hidden">
  <div
    class="flex items-center justify-center shrink-0 w-20 h-20 text-[7px] text-old-transparent
      bg-none ring-inset ring-1 ring-old-n-gray-70 rounded-4 outline-none
      transition-all duration-300
      icon-save
      peer-hover:ring-old-n-gray-80
      peer-focus:ring-old-n-gray-80
      peer-checked:bg-old-n-black-100 peer-checked:text-old-white peer-checked:ring-old-n-black-100
      peer-checked:peer-hover:bg-old-n-black-90 peer-checked:peer-hover:ring-old-n-black-90
      peer-checked:peer-focus:bg-old-n-black-90 peer-checked:peer-focus:ring-old-n-black-90"/>
</template>

<script lang="ts" setup generic="T">
const model = defineModel<boolean | Array<T> | undefined>();
defineProps<{ value?: T }>();
</script>
